import { render, staticRenderFns } from "./Solicitantes.vue?vue&type=template&id=1794349d&scoped=true"
import script from "./Solicitantes.vue?vue&type=script&lang=js"
export * from "./Solicitantes.vue?vue&type=script&lang=js"
import style0 from "./Solicitantes.vue?vue&type=style&index=0&id=1794349d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1794349d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1794349d')) {
      api.createRecord('1794349d', component.options)
    } else {
      api.reload('1794349d', component.options)
    }
    module.hot.accept("./Solicitantes.vue?vue&type=template&id=1794349d&scoped=true", function () {
      api.rerender('1794349d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/notificaciones/completaInfo/Solicitantes.vue"
export default component.exports